<section
  class="relative"
  *transloco="let t; prefix: 'property-details.hero-section'"
>
  <div class="container">
    <button 
      (click)="GoBack()"
      class="text-black py-[6px] my-6 font-semibold flex gap-2 justify-center items-center"
    >
      <i *ngIf="hasPreviousPage" class="icon-arrow-left"></i>{{ hasPreviousPage ? t("buttons.back") :'' }}
    </button>
      @if(!(platform.ANDROID || platform.IOS) && platform.isBrowser) {
        <div class="grid grid-cols-5 grid-rows-2 gap-3 rounded-medium overflow-hidden h-[490px]">
          <div class="row-span-2 col-span-5 lg:col-span-3">
            <div class="relative h-full" (click)="openModalComponent()">
              @if (model.isSold) {
                <div class="backdrop-blur-sm backdrop-grayscale-[0.8] backdrop-contrast-50 h-full w-full absolute top-0 flex justify-center items-center rounded-lg overflow-hidden z-10">
                  <div class="w-[144px]">
                    <img class="w-full" src="./assets/img/keys.svg" alt="">
                  </div>
                </div>
                <div class="sold-banner">
                  SOLD
                </div>
            }
              <div class="relative px-4 py-5 z-10 flex flex-col justify-between h-full cursor-pointer">
                <div class="flex flex-row justify-between">
                  <div class="flex flex-row flex-wrap gap-2 text-white">
                    <div *ngIf="model.isHot && !model.isSold" class="property-label red max-h-fit">
                      <i class="icon-fire-alt mr-1"></i>
                      <span>{{ t("tags.hot") }}</span>
                    </div>
                    <div *ngIf="model.isExclusive && !model.isSold" class="property-label bg-[#059B9C] max-h-fit flex items-center gap-1">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M10 5.12333V9.74463C10 9.8861 9.87618 10 9.72416 10H8.78928C8.63647 10 8.51266 9.88538 8.51266 9.74463V5.3446C8.51266 5.28366 8.48915 5.22417 8.44526 5.17774L5.20884 1.7027C5.09835 1.58445 4.90087 1.58445 4.79038 1.7027L1.55395 5.17774C1.51085 5.22417 1.48656 5.28366 1.48656 5.3446V8.65569C1.48656 8.79716 1.61038 8.91106 1.76318 8.91106H4.01144C4.16425 8.91106 4.28806 8.79643 4.28806 8.65569V5.8713C4.28806 5.72983 4.41188 5.61521 4.56469 5.61521H5.44315C5.59596 5.61521 5.71977 5.72983 5.71977 5.8713V9.74391C5.71977 9.88537 5.59596 9.99928 5.44315 9.99928H0.276624C0.123815 9.99928 0 9.88465 0 9.74391V5.12261C0 5.05949 0.0250764 4.99855 0.0705274 4.95139L4.79429 0.084881C4.904 -0.0282937 5.09521 -0.0282937 5.20492 0.084881L9.92869 4.95212C9.97414 4.99927 9.99922 5.06021 9.99922 5.12333H10Z"
                          fill="white" />
                      </svg>
                      <span>{{t('tags.exclusive')}}</span>
                    </div>
                    <div
                      *ngIf="model?.auctionRound && !model.isSold"
                      class="property-label bg-[#3B61C1] max-h-fit"
                    >
                      {{ t("tags.auction") }}
                    </div>
                    <div
                      *ngIf="model?.isSponsored"
                      class="property-label orange max-h-fit"
                    >
                      {{ t("tags.sponsored") }}
                    </div>
                  </div>
                  <div
                    *ngIf="model?.preApproved === 'Approved' && !model.isSold"
                    class="bg-[#037079CC] py-2 px-4 backdrop-blur rounded-small flex flex-row items-center gap-3"
                  >
                    <span class="text-white font-bold text-[0.546875rem]">{{
                      t("default-image.nbg-aproved")
                    }}</span>
                    <img class="h-[14px]" src="{{'../../../../../assets/svgs/nbg-logo' + (activeLang === 'el' ? '-white' : '') + '.svg'}}" />
                  </div>
                </div>
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
              </div> 
              <img
                [src]="model.defaultPhoto?.uri ? model.defaultPhoto?.uri+(model.publishedVersion ? '?v='+model.publishedVersion : '') : model.defaultImagePath"
                class="cursor-pointer w-full h-full object-cover object-center img-disable-context absolute top-0 left-0 bottom-0 right-0 -z-1 cursor-pointer"
              />
            </div>
          </div>
          @for (photo of getDisplayItems(); track $index) {
            @if (!isPlaceholder(photo?.uri) && photo?.uri && !photo.isDefault) {
              <div class="bg-gray-100 hidden lg:flex items-center justify-center relative cursor-pointer" (click)="openModalComponent()">
                <div *ngIf="model?.isSold && !photo.isDefault" class="backdrop-blur-sm backdrop-grayscale absolute w-full h-full"></div>
                <img
                  [ngClass]="{
                    'object-cover w-full h-full img-disable-context': !photo.isDefault
                  }"
                  [src]="photo.uri || placeholderUri"
                  [alt]="photo.altText"
                />
              </div>
            } @else {
              <div class="bg-gray-100 hidden lg:flex items-center justify-center relative cursor-not-allowed">
                <img
                  [src]="placeholderUri"
                  alt=""
                />
              </div>
            }
          }
        </div>
      } @else if (platform.ANDROID || platform.IOS) {
        <section class="flex flex-col gap-6">
          <ng-template [cdkPortalOutlet]="swiperPortal">
          </ng-template>
          <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </section>
      }
  </div>

  <ng-template #buttons>
    <div class="flex flex-row items-center justify-between">
      <div class="flex flex-row items-center gap-2">
        <button
          type="button"
          (click)="openModalComponent($event)"
          class="btn-secondary-sm bg-white"
        >
          {{ photos?.count }} {{ t("default-image.photos") }}
        </button>
        @if (floorPlanExists) {
          <button class="btn-secondary-sm bg-white"
            type="button"
            (click)="openFloorPlanComponent()">
            {{ t("default-image.floor-plan") }}
          </button>
        }
      </div>
      <div *ngIf="vrCode">
        <button
          (click)="openVrModalComponent(); $event.stopPropagation()"
          type="button"
          class="bg-[#D0FBE4E5] backdrop-blur-sm border text-black text-sm font-semibold border-primary-500 px-4 rounded-full py-2"
        >
          {{ t("default-image.vr-toor") }}
          <i class="icon-marker-pin"></i>
        </button>
      </div>
    </div>
  </ng-template>
</section>

